'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

var _imageComponent = require('./image-component');

var _imageComponent2 = _interopRequireDefault(_imageComponent);

var _formatting = require('../../../utils/formatting');

var _assets = require('../../../utils/assets');

var _style = require('./style');

var _supporingDataModal = require('../../../components/supporing-data-modal');

var _supporingDataModal2 = _interopRequireDefault(_supporingDataModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ManualDataComponent = function ManualDataComponent(_ref) {
  var asset = _ref.asset,
      deleteCallback = _ref.deleteCallback;

  var supportingData = _lodash2.default.get(asset, 'supportingData', []);
  var isTelegram = asset.assetURL && asset.assetURL.match(/\/\/t.me\//i);
  var impressions = (0, _assets.getSupportingDataField)(supportingData, 'impressions', null);
  var reach = (0, _assets.getSupportingDataField)(supportingData, 'reach', null);
  var views = (0, _assets.getSupportingDataField)(supportingData, 'views', null);
  var likes = (0, _assets.getSupportingDataField)(supportingData, 'likes', null);
  var shares = (0, _assets.getSupportingDataField)(supportingData, 'shares', null);
  var comments = (0, _assets.getSupportingDataField)(supportingData, 'comments', null);
  var icon = (0, _assets.resolvePlatformIcon)(asset.platform);
  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    null,
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'div',
          null,
          isTelegram ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'telegram plane', color: 'blue', size: 'large' }) : _react2.default.createElement(_semanticUiReact.Icon, { name: icon.name, color: icon.color }),
          _lodash2.default.get(asset, 'assetType') === 'VIDEO' && _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube play', color: icon.color }),
          _lodash2.default.get(asset, 'assetType') === 'IMAGE' && _react2.default.createElement(_semanticUiReact.Icon, { name: 'image', color: icon.color }),
          _react2.default.createElement(
            'p',
            { style: _style.smallFont },
            (0, _formatting.formatAssetPublishedData)(asset)
          )
        ),
        content: (0, _formatting.getAssetPublishedDateMessage)(asset)
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_imageComponent2.default, { post: asset })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'left' },
      _react2.default.createElement(
        _semanticUiReact.Header,
        { as: 'h5' },
        _react2.default.createElement(
          _semanticUiReact.Header.Content,
          { style: _style.ellipsisWrapper },
          _lodash2.default.get(asset, 'discussionName'),
          _react2.default.createElement(
            _semanticUiReact.Header.Subheader,
            null,
            _react2.default.createElement(
              'span',
              { style: _style.ellipsisWrapper },
              _lodash2.default.get(asset, 'extraData.text') || '(uncaptioned)'
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_supporingDataModal2.default, { asset: asset })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(
        'b',
        { style: _style.dyzioGreen },
        'Manual'
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      views ? (0, _formatting.sciFormatted)(views) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      reach ? (0, _formatting.sciFormatted)(reach) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      impressions ? (0, _formatting.sciFormatted)(impressions) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      likes ? (0, _formatting.sciFormatted)(likes) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      comments ? (0, _formatting.sciFormatted)(comments) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      shares ? (0, _formatting.sciFormatted)(shares) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      '-'
    ),
    deleteCallback && _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      '-'
    )
  );
};

ManualDataComponent.propTypes = {
  asset: _propTypes2.default.object.isRequired
};

exports.default = ManualDataComponent;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/basic-report-row/components/manual-data-component.js
 ** module id = 2605
 ** module chunks = 0
 **/